export async function loadGeminiResponse() {
  const container = document.getElementById('gemini-response');
  if (!container) return;

  try {
    const response = await fetch('/api/who-is-jed');
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Request failed');
    }

    container.textContent = data.answer;
    container.classList.add('gemini-loaded');
  } catch {
    container.textContent = 'Gemini is thinking offline — check back soon.';
    container.classList.add('gemini-error');
  }
}
